// Will get overwritten in production
export const API_TOKEN = () => localStorage.getItem('claresse_token');
export const API_URL='https://claresse.meierij.it/customer-api';
